<template>
   <button class="close" type="button" aria-label="Close"  @click="$emit('closeModal')">
      <span aria-hidden="true"> <i class="fa fa-times"></i></span>
    </button>
</template>